import { docodeHexResponse } from "../../_common/common.utils";
import tcnResponseTypes from "./tcnResponse.types";
const INIITIAL_STATE = {
  tcnResponseStatus: null,
  tcnSearchResponse: [],
  tcnDispositionGroupResponse: null,
  tcnDispositionGroupArr: [],
  tcnExportResponse: null,
  selectTcnResponseExportResponse: null,
  selectTcnResponseExportResponseArr: [],
  exportTcnResponseStatus: "",
};

const tcnResponseReducer = (state = INIITIAL_STATE, action: any) => {
  switch (action.type) {
    case tcnResponseTypes.TCN_RESPONSE_SEARCH_SUCCESS:
      return {
        ...state,
        tcnResponseStatus: action.payload,
        tcnSearchResponse: docodeHexResponse(action.payload, "TCNResponseKey"),
      };

    case tcnResponseTypes.TCN_RESPONSE_SEARCH_FAILURE:
      return {
        ...state,
        tcnResponseStatus: action.payload,
        tcnSearchResponse: [],
      };

    case tcnResponseTypes.TCN_RESPONSE_SEARCH_CHANGED:
      return {
        ...state,
        tcnResponseStatus: null,
      };

    case tcnResponseTypes.TCN_DISPOSITION_GROUP_SUCCESS:
      return {
        ...state,
        tcnDispositionGroupResponse: action.payload,
        tcnDispositionGroupArr: docodeHexResponse(
          action.payload,
          "GetAllGroupDispositionKey",
        ),
      };

    case tcnResponseTypes.TCN_DISPOSITION_GROUP_FAILURE:
      return {
        ...state,
        tcnDispositionGroupResponse: action.payload,
        tcnDispositionGroupArr: [],
      };

    case tcnResponseTypes.TCN_DISPOSITION_GROUP_RESPONSE_CHANGED:
      return {
        ...state,
        tcnDispositionGroupResponse: null,
      };

    case tcnResponseTypes.TCN_RESPONSE_EXPORT_SUCCESS:
      return {
        ...state,
        selectTcnResponseExportResponse: action.payload,
        selectTcnResponseExportResponseArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
        exportTcnResponseStatus: "Success",
      };

    case tcnResponseTypes.TCN_RESPONSE_EXPORT_FAILURE:
      return {
        ...state,
        selectTcnResponseExportResponse: action.payload,
        selectTcnResponseExportResponseArr: [],
        exportTcnResponseStatus: "Failure",
      };

    case tcnResponseTypes.TCN_RESPONSE_EXPORT_CHANGED:
      return {
        ...state,
        selectTcnResponseExportResponse: null,
        exportTcnResponseStatus: "",
      };

    default:
      return state;
  }
};

export default tcnResponseReducer;
